import { Button, Checkbox, Label } from '~/components/ui'
import { STATUSES } from '~/constants'

export default function MapListingStatusFilter({
  statuses,
  updateFilter,
}: {
  statuses: string[]
  updateFilter: (key: string, value: any) => void
}) {
  const setStatuses = (status: string, value: boolean) => {
    if (value) {
      updateFilter('statuses', [...statuses, status])
    } else {
      const newStatuses = statuses.filter((p) => p !== status)
      updateFilter('statuses', newStatuses.length > 0 ? newStatuses : [])
    }
  }

  return (
    <div className="space-y-2">
      <p className="text-sm">
        Status
        {(statuses.length > 1 ||
          (statuses.length > 0 && statuses[0] !== 'active')) && (
          <Button
            variant="link"
            size="none"
            className="ml-2"
            onClick={() => updateFilter('statuses', ['active'])}>
            (reset)
          </Button>
        )}
      </p>
      <div className="grid grid-cols-2 gap-4">
        {Object.keys(STATUSES).map((key) => {
          if (key === 'draft') {
            return null
          }
          return (
            <Label
              key={key}
              htmlFor={`status-${key}`}
              className="flex items-center gap-2 text-sm font-normal">
              <Checkbox
                id={`status-${key}`}
                checked={statuses.includes(key)}
                onCheckedChange={(value: boolean) => {
                  setStatuses(key, value)
                }}
              />
              <span className="text-base md:text-sm">{STATUSES[key]}</span>
            </Label>
          )
        })}
      </div>
    </div>
  )
}
